// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2t91e","content":"LayoutSettings_content__32ald"};